export default __webpack_public_path__ + "static/media/Formular-Medium.473c4320.eot";